/**
 * Task JJ: import mapping — any field for any column (several columns per field), our own field picker (phones), side-by-side
 * repeated groups split into records, error-report helper columns ignored. One row per key: [key, English, 中文]; Malay = English.
 */
const ROWS = [
  ["jj.pick.title","Column {n} “{h}” — import as","第 {n} 栏「{h}」导入为"],
  ["jj.pick.close","Close","关闭"],
  ["jj.pick.usedBy","also column {cols}","也用于第 {cols} 栏"],
  ["jj.pick.combine","several columns are combined","可多栏合并"],
  ["jj.g.basic","Basic details","基本资料"],
  ["jj.g.contact","Contact","联系"],
  ["jj.g.member","Membership","会员"],
  ["jj.g.packages","Packages & stored value","配套储值"],
  ["jj.g.other","Other","其他"],
  ["jj.multi.first","“{f}” is also used by column {cols}: each row uses the first filled column (left to right).","「{f}」也用于第 {cols} 栏：每行使用第一个有内容的栏（从左到右）。"],
  ["jj.multi.combine","“{f}” is also used by column {cols}: the values are combined.","「{f}」也用于第 {cols} 栏：内容会合并在一起。"],
  ["jj.multi.only","Use only this column","只用这一栏"],
  ["jj.multi.summary","Several columns → one field: {list}","多栏对应同一栏位：{list}"],
  ["jj.multi.item","“{f}” ← columns {cols}","「{f}」← 第 {cols} 栏"],
  ["jj.split.ask","This file has {n} sets of customer details in each row ({sets}). Import them as {n} separate customers?","这个文件每行有 {n} 组顾客资料（{sets}），要拆成 {n} 位顾客导入吗？"],
  ["jj.split.set","set {g}: columns {cols}","第 {g} 组：第 {cols} 栏"],
  ["jj.split.yes","Yes, split into {n} customers","拆成 {n} 位顾客导入"],
  ["jj.split.no","No, one customer per row","不用，每行一位顾客"],
  ["jj.split.on","Split: each row becomes up to {n} customers (empty sets are left out). Problems name the set, e.g. “row 12 (set 2)”.","已拆分：每行最多导入 {n} 位顾客（空的组不导入）。问题会写成“第 12 行（第 2 组）”。"],
  ["jj.split.off","Undo the split","取消拆分"],
  ["jj.split.declined","Imported as one customer per row.","按每行一位顾客导入。"],
  ["jj.split.ask2","Split into customers again","改为拆分导入"],
  ["jj.split.tag","set {g}","第 {g} 组"],
  ["jj.split.inherit","same field as set 1","按第 1 组的栏位"],
  ["jj.helper","Columns {cols} (“Row” / “Problem”) come from the error report and are not imported.","第 {cols} 栏（Row / Problem）是错误报告的辅助栏，不会导入。"],
  ["jj.suggest","AI suggestion: {f} ({p}%)","AI 建议：{f}（{p}%）"],
  ["jj.suggest.use","Use","使用"],
] as const;

export type JjKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<JjKey, string>;

export const taskJJ = { en: col(1), zh: col(2), ms: col(1) };
